import './ImportComponentBadge.css';

const COPIED_LABEL = 'Copied!';
const DEFAULT_LABEL = 'Copy ID';
const RESET_MS = 2000;

const fallbackCopyToClipboard = (text: string): boolean => {
    const textArea: HTMLTextAreaElement = document.createElement('textarea');
    textArea.value = text;
    textArea.setAttribute('readonly', '');
    textArea.style.position = 'fixed';
    textArea.style.left = '-9999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
        return document.execCommand('copy');
    } catch {
        return false;
    } finally {
        document.body.removeChild(textArea);
    }
};

const copyText = async (text: string): Promise<boolean> => {
    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch {
            return fallbackCopyToClipboard(text);
        }
    }
    return fallbackCopyToClipboard(text);
};

const moveBadgeIntoComponent = (badge: HTMLButtonElement): void => {
    const targetId: string = badge.dataset.ssImportTarget ?? '';
    if (targetId === '') {
        badge.remove();
        return;
    }
    const target: HTMLElement | null = document.getElementById(targetId);
    if (target === null) {
        badge.remove();
        return;
    }
    const computedPosition: string = window.getComputedStyle(target).position;
    if (computedPosition === 'static') {
        target.style.position = 'relative';
    }
    target.appendChild(badge);
};

const handleBadgeClick = (badge: HTMLButtonElement): void => {
    const componentId: string = badge.dataset.componentId ?? '';
    if (componentId === '') {
        return;
    }

    const resetLabel = (): void => {
        badge.textContent = DEFAULT_LABEL;
        badge.classList.remove('is-copied');
    };

    void copyText(componentId).then((copied: boolean) => {
        if (!copied) {
            return;
        }
        badge.textContent = COPIED_LABEL;
        badge.classList.add('is-copied');
        window.setTimeout(resetLabel, RESET_MS);
    });
};

export const initImportComponentBadges = (): void => {
    const badges: NodeListOf<HTMLButtonElement> = document.querySelectorAll('.ss-import-component-badge');
    badges.forEach((badge: HTMLButtonElement) => {
        moveBadgeIntoComponent(badge);
        badge.addEventListener('click', () => {
            handleBadgeClick(badge);
        });
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initImportComponentBadges);
} else {
    initImportComponentBadges();
}
